import { lazy } from 'react';

export const ModelPageLazy = lazy(() => import('./ModelPage'));
